/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  mainContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bodyContainer: {
    width: '100%',
    // minHeight: '120px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '1.25rem',

    '@media(max-width: 599px)': {
      // minHeight: '295px',
      // paddingTop: '38px',
      marginTop: '0px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingBottom: '32px',
      flexDirection: 'column',
      justifyContent: 'center',
    },

    '& .brand-password': {
      maxWidth: '376px',
      margin: '0 auto',
      textAlign: 'left',

      marginTop: '-2.19px',
      paddingBottom: '42.19px',

      '@media(max-width: 599px)': {
        marginTop: '0px',
        paddingTop: '12px',
        paddingBottom: '24px',
      },

      '& .password-brand-type': {
        fontFamily: theme.typography.subtitle2.fontFamily,
        fontStyle: 'normal',

        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: theme.typography.subtitle2.lineHeight,
        color: theme.palette.primary.textColor3,
        opacity: '0.8',

        paddingBottom: '4px',

        '@media(max-width: 599px)': {
          paddingBottom: '3px',
        },
      },

      '& .password-brand-type-hide-brandName': {
        visibility: 'hidden',
      },

      '& .password-brand-number': {
        fontFamily: theme.typography.body2.fontFamily,
        fontStyle: 'normal',

        fontSize: theme.typography.body2.fontSize,
        lineHeight: theme.typography.body2.lineHeight,
        color: theme.palette.primary.textColor3,
        opacity: '0.8',
      },
    },

    '& .text-field': {
      position: 'relative',
      maxWidth: '376px',
      // minHeight: "79px",
      // margin: '0 auto',
      width: '46%',
      // paddingBottom: '2.5rem',

      '@media(min-width: 0px) and (max-width: 599px)': {
        width: '132%',
        paddingBottom: '0rem',
        marginTop: '1rem',
        marginLeft: '-26px',
      },
      '@media(min-width: 320px) and (max-width: 599px)': {
        width: '110%',
        paddingBottom: '0rem',
        marginTop: '1rem',
        marginLeft: '-16px',
      },

      '& .visibility-off, & .visibility-on': {
        position: 'absolute',
        top: '0.75rem',
        right: '12px',
        color: theme.palette.primary.textColor3,
        opacity: '0.8',
        cursor: 'pointer',
      },
      '& .visibility-disable': {
        position: 'absolute',
        top: '0.75rem',
        right: '12px',
        color: theme.palette.primary.textColor3,
        opacity: '0.5',
        pointerEvents: 'none',
      },

      '& .text-field-name': {
        fontFamily: theme.typography.inputLabel.fontFamily,
        fontStyle: 'normal',

        fontSize: theme.typography.inputLabel.fontSize,
        lineHeight: theme.typography.inputLabel.lineHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.primary.eirButton,

        position: 'absolute',
        top: '-6px',
        left: '12px',

        maxWidth: '62px',
        background: '#FFFFFF',
      },

      '& .text-field-name-invalid': {
        color: theme.palette.primary.buttonColor,
      },

      '& .input-text': {
        fontFamily: theme.typography.body1.fontFamily,
        fontStyle: 'normal',

        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.body1.lineHeight,
        display: 'flex',
        alignItems: 'center',
        letterSpacing: '0.15px',

        width: '100%',
        minHeight: '48px',
        paddingLeft: '12px',
        paddingRight: '12px',

        border: `1px solid ${theme.palette.primary.boxShadow4Lite}`,
        boxSizing: 'border-box',
        borderRadius: '4px',
      },

      '& .input-text:focus': {
        outline: 'transparent',
      },

      '& .visibility-icon-padding': {
        paddingRight: '44px',
      },

      '& .text-empty': {
        outlineColor: theme.palette.primary.boxShadow4Lite,
        color: theme.palette.primary.textColor3,
        // opacity: '0.5',
      },

      '& .text-entered': {
        border: `2px solid${theme.palette.primary.buttonColor}`,
        outlineColor: theme.palette.primary.buttonColor,
        color: theme.palette.primary.textColor3,
        // opacity: '0.8',
      },

      '& .text-entered-invalid': {
        border: `2px solid ${theme.palette.primary.buttonColor}`,
        outlineColor: theme.palette.primary.buttonColor,
        color: theme.palette.primary.textColor3,
        // opacity: '0.8',
      },

      '& .invalid-email-format, & .username-not-found': {
        fontFamily: theme.typography.helperText.fontFamily,
        fontStyle: 'normal',

        fontSize: theme.typography.helperText.fontSize,
        lineHeight: theme.typography.helperText.lineHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        letterSpacing: '0.4px',
        color: theme.palette.primary.buttonColor,

        marginTop: '3px',
      },

      '& .error-and-reset': {
        display: 'flex',
      },

      '& .username-not-found': {
        flexGrow: '1',
        paddingRight: '20px',
        textAlign: 'left',
      },

      '& .reset-password': {
        flexGrow: '0',

        fontFamily: theme.typography.helperText.fontFamily,
        fontStyle: 'normal',

        fontSize: theme.typography.helperText.fontSize,
        lineHeight: theme.typography.helperText.lineHeight,
        letterSpacing: '0.4px',
        textDecorationLine: 'underline',
        color: theme.palette.primary.buttonColor,
        opacity: '0.8',

        marginTop: '3px',
        cursor: 'pointer',
      },

      '& .forgotten-input-text': {
        fontFamily: theme.typography.body2.fontFamily,
        fontStyle: 'normal',
        fontSize: theme.typography.body2.fontSize,
        lineHeight: theme.typography.body2.lineHeight,
        display: 'flex',
        alignItems: 'center',
        letterSpacing: '0.4px',
        color: theme.palette.primary.buttonColor,
        // opacity: '0.5',
        textDecoration: 'underline',
        cursor: 'pointer',
        marginTop: '3px',
      },

      '& .disabled-forgotten-input-text': {
        fontFamily: theme.typography.body2.fontFamily,
        fontStyle: 'normal',
        fontSize: theme.typography.body2.fontSize,
        lineHeight: theme.typography.body2.lineHeight,
        display: 'flex',
        alignItems: 'center',
        letterSpacing: '0.4px',
        color: theme.palette.primary.buttonColor,
        // opacity: '0.5',
        textDecoration: 'underline',
        cursor: 'pointer',
      },

      '& .remember-me-next-time': {
        textAlign: 'left',
        marginTop: '26px',
        display: 'flex',
        alignItems: 'center',

        '& .remember-me': {
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',

          '& .checkbox-unchecked, & .checkbox-checked': {
            width: '22px',
            height: '22px',
            color: theme.palette.primary.textColor3,
            opacity: '0.5',
          },

          '& p': {
            fontFamily: theme.typography.helperText.fontFamily,
            fontStyle: 'normal',

            fontSize: theme.typography.helperText.fontSize,
            lineHeight: theme.typography.helperText.lineHeight,
            color: theme.palette.primary.textColor3,
            opacity: '0.8',

            marginBottom: '0px',
            marginLeft: '7px',
          },
        },
      },
    },

    '& .accounts-field': {
      maxWidth: '377px',
      paddingTop: '19px',
      margin: '0 auto',
      textAlign: 'left',

      '@media(max-width: 599px)': {
        paddingTop: '8px',
      },

      '& .accounts-header': {
        fontFamily: theme.typography.subtitle1.fontFamily,
        fontStyle: 'normal',

        fontSize: theme.typography.subtitle1.fontSize,
        lineHeight: theme.typography.subtitle1.lineHeight,
        color: theme.palette.primary.textColor3,
        opacity: '0.8',

        '@media(max-width: 599px)': {
          paddingLeft: '8px',
        },
      },

      '& .accounts-list': {
        marginTop: '27px',

        '@media(max-width: 599px)': {
          marginTop: '18px',
        },

        '& .accounts-list-item': {
          position: 'relative',
          padding: '15.81px 8px 9.19px 8px',
          marginBottom: '1px',
          boxShadow: `0px 1px 0px ${theme.palette.primary.buttonColor}`,
          cursor: 'pointer',

          '& .account-type': {
            fontFamily: theme.typography.subtitle2.fontFamily,
            fontStyle: 'normal',

            fontSize: theme.typography.subtitle2.fontSize,
            lineHeight: theme.typography.subtitle2.lineHeight,
            color: theme.palette.primary.textColor3,
            opacity: '0.8',

            paddingBottom: '4px',
          },

          '& .account-type-hide-brandName': {
            display: 'none',
          },

          '& .account-number': {
            fontFamily: theme.typography.body2.fontFamily,
            fontStyle: 'normal',

            fontSize: theme.typography.body2.fontSize,
            lineHeight: theme.typography.body2.lineHeight,
            color: theme.palette.primary.textColor3,
            opacity: '0.8',
          },

          '& .account-arrow-right': {
            position: 'absolute',
            color: theme.palette.primary.eirButton,
            width: '14.8px',

            top: '20px',
            right: '5px',
          },
        },

        '& .accounts-list-item-hide-brandName': {
          display: 'flex',
          alignItems: 'center',
          minHeight: '65px',
        },

        '& .accounts-list-item:hover': {
          boxShadow: `0px 2px 1px ${theme.palette.secondary.errorCTA}`,
          padding: '15.81px 8px 8.19px 8px',
          marginBottom: '2px',
        },
      },
    },
  },
  reCaptchaError: {
    margin: '0 auto',
    display: 'flex',
    '@media(min-width:600px)': {
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  reCaptcha: {
    paddingTop: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingTop: '39px',
      transform: 'scale(0.77)',
      transformOrigin: '0 0',
    },
    '@media(min-width:600px) and (max-width:1019px)': {
      paddingTop: '39px',
      marginLeft: '75px',
    },
  },
  altCtaTextButton: {
    color: theme.palette.primary.OfferSelected,
    fontSize: theme.typography.body1.fontSize,
    fontFamily: theme.typography.body1.fontFamily,

    textDecoration: 'underline',
    textTransform: 'unset',
  },
  descriptionNew: {
    fontSize: theme.typography.body2.fontFamily,
    paddingLeft: '20px',
    paddingRight: '20px',
    '@media(min-width: 0px) and (max-width: 290px)': {
      marginLeft: '-20px',
      marginRight: '-36px',
      paddingLeft: '0px',
      paddingRight: '19px',
    },
    '@media(min-width: 290px) and (max-width:1024px)': {
      paddingLeft: '0px',
      paddingRight: '0px',
      marginLeft: '15px',
      marginRight: '12px',
    },
  },
  secondHalfDescription: {
    color: theme.palette.primary.textColor3,

    fontFamily: theme.typography.subtitle1.fontFamily,
    fontSize: theme.typography.subtitle2.fontSize,
  },
  MobileClass: {
    height: { xs: 200 },
    width: { xs: 200 },
  },
  BroadbandClass: {
    height: { xs: 200 },
    width: { xs: 200 },
  },
});
export default styles;
